document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.faq-navigation__tab');
    
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            const sectionId = this.getAttribute('data-section-id');
            const targetSection = document.getElementById(sectionId);
            tabs.forEach(tab => tab.classList.remove('active'));
            this.classList.add('active');
            
            if (targetSection) {
                const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
                const viewportHeight = window.innerHeight;
                const scrollToPosition = targetPosition - (viewportHeight * 0.2);
                
                window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                });
            } else {
                console.warn(`Section with ID "${sectionId}" not found.`);
            }
        });
    });
});